import type { IconProps } from '../types/IconProps.ts';
export const HeartOff: IconProps = {
    name: 'HeartOff',
    children: [
        `<path d="m16.73 16.82-4.54 4.01c-.1.1-.27.1-.38 0l-8.1-7.16A5.07 5.07 0 0 1 5 5.25M19 14.81l1.29-1.14a5.07 5.07 0 1 0-7.06-7.25L12.04 7.7h-.08l-1.19-1.27a5 5 0 0 0-1.27-1M2 2l20 20" />`,
    ]
};